import { render } from "./LaunchDonate.vue?vue&type=template&id=1cd381fa&scoped=true"
import script from "./LaunchDonate.vue?vue&type=script&lang=js"
export * from "./LaunchDonate.vue?vue&type=script&lang=js"

import "./LaunchDonate.vue?vue&type=style&index=0&id=1cd381fa&scoped=true&lang=css"

import exportComponent from "D:\\eazyc\\ezDev\\ECS-Cognitive\\cognitive-screening-mobile-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cd381fa"]])

export default __exports__